export const naturalSort = (a: string, b: string): number => {
  // Split strings into numeric and non-numeric tokens
  const regex = /(\d+)|([^\d]+)/g;
  const aParts = String(a).match(regex) || [];
  const bParts = String(b).match(regex) || [];

  const minLen = Math.min(aParts.length, bParts.length);
  for (let i = 0; i < minLen; i++) {
    const aNum = Number(aParts[i]);
    const bNum = Number(bParts[i]);

    // Compare numeric parts numerically, others lexicographically
    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
    const diff = bothNumeric
      ? aNum - bNum
      : aParts[i].localeCompare(bParts[i]);

    if (diff !== 0) return diff;
  }

  // If all parts equal, shorter string wins
  return aParts.length - bParts.length;
}; 